import React, { Component } from "react";
import FlexView from "react-flexview";
import M from "moment";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../Services/Api";
import { mapToObjectDDL } from "../../../common/mapper";
import { fetchDataAsync } from "../../../../Services/Utils";

class beforeSubmissionFilter extends Component {
  statusOptions = [
    { label: "Ready", value: "Ready" },
    { label: "Received", value: "Received" },
    { label: "Not Ready", value: "Not Ready" },
  ];

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: {},
      dataVariant: [],
      dataWarna: [],
      allDataWarna: [],
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchDataVariant();
    this.handleTriggerLoading();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.visible && !prevProps.visible) {
      if (
        Array.isArray(this.props.filterData.kodeVariant) &&
        this.props.filterData.kodeVariant.length > 0 &&
        this.state.dataVariant.length > 0 
      ) {
        let kodeVariants = this.props.filterData.kodeVariant.map(v => v.value);

        if (kodeVariants.includes("ALL")) {
          kodeVariants = this.state.dataVariant
            .filter(item => item.value !== "ALL")
            .map(item => item.value);
        }

        this.fetchDataWarna(kodeVariants);
      }
    }
  }

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchDataVariant = async () => {
    try {
      let response = await Api.create("NAGAMAS_MASTER_DATA").getVariantByCabang(
        this.props.selectedCabang.value
      );
    
      if (response.ok) {
        const dataVariant = [
          { label: "ALL", value: "ALL" },
          ...response.data.data.map((item) =>
            mapToObjectDDL(item.namaVariant, item.kodeVariant)
          ),
        ];
      
        this.setState(
          {
            dataVariant,
          },
          async () => {
            if (
              Array.isArray(this.props.filterData.kodeVariant) &&
              this.props.filterData.kodeVariant.length > 0
            ) {
              let kodeVariants = this.props.filterData.kodeVariant.map((v) => v.value);
            
              if (kodeVariants.includes("ALL")) {
                kodeVariants = dataVariant
                  .filter((item) => item.value !== "ALL")
                  .map((item) => item.value);
              }
            
              await this.fetchDataWarna(kodeVariants);
            }
          }
        );
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataWarna = async (kodeVariants) => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByListKodeVariant,
        setError: this.props.setError,
        menuName: "Penyerahan BBN",
        args: kodeVariants,
      });
    
      if (response.ok) {
        const allWarna = response.data.data.map((item) => ({
          ...mapToObjectDDL(item.namaWarnaPabrik, item.id),
          kodeVariant: item.kodeVariant,
        }));
        if (
          Array.isArray(this.props.filterData.kodeVariant) &&
          this.props.filterData.kodeVariant.some((v) => v.value === "ALL")
        ) {
          this.setState((prevState) => ({
            ...prevState,
            dataWarna: [{ label: "ALL", value: "ALL" }, ...allWarna],
            allDataWarna: allWarna,
          }));
        } else {
          this.setState((prevState) => ({
            ...prevState,
            dataWarna: [{ label: "ALL", value: "ALL" }, ...allWarna],
            allDataWarna: allWarna,
          }));
        }
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };


  handleChangeVariant = async (value, { name }) => {
    let currKodeVariants = Array.isArray(value)
      ? value.map((v) => v.value)
      : [];

    const prevKodeVariants = Array.isArray(this.props.filterData.kodeVariant)
      ? this.props.filterData.kodeVariant.map((v) => v.value)
      : [];

    const removedVariants = prevKodeVariants.filter(
      (prev) => !currKodeVariants.includes(prev)
    );

    this.props.onValueChange(name, value);
    if (!value || value.length === 0) {
      this.props.onValueChange("kodeWarna", []);
      this.setState((prevState) => ({
        ...prevState,
        dataWarna: [],
      }));
      return;
    }

    if (currKodeVariants.includes("ALL")) {
      currKodeVariants = this.state.dataVariant
        .filter((item) => item.value !== "ALL")
        .map((item) => item.value);
        
      this.props.onValueChange(
        name,
        this.state.dataVariant.filter((item) => item.value === "ALL")
      );
    
      this.props.onValueChange("kodeWarna", []);
    }

    if (removedVariants.length > 0) {
      const prevWarna = this.props.filterData.kodeWarna || [];

      const filteredWarna = prevWarna.filter(
        (warna) => !removedVariants.includes(warna.kodeVariant)
      );
    
      this.props.onValueChange("kodeWarna", filteredWarna);
    }
    await this.fetchDataWarna(currKodeVariants);
  };


  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.visible}
        onClickClose={() => this.props.onClickClose()}
        content={
          <ModalContainer>
            <FlexView column>
              <FlexView column vAlignContent="center">
                <p>Tanggal Faktur Jual:</p>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleDate
                    date={this.props.filterData.startDate}
                    onChange={(value) =>
                      this.props.onValueChange(
                        "startDate",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                  <span className="margin-bottom-20px">To</span>
                  <SimpleDate
                    date={this.props.filterData.endDate}
                    onChange={(value) =>
                      this.props.onValueChange(
                        "endDate",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                </FlexView>
              </FlexView>
              <SimpleInput
                id="input_text_sales_invoice_number"
                name="noFakturJual"
                label="Nomor Faktur Jual"
                value={this.props.filterData.noFakturJual}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_book_number"
                name="noBuku"
                label="No Buku"
                value={this.props.filterData.noBuku}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleDDL
                id={`select_options_nama_varian`}
                name="kodeVariant"
                label="Nama Varian"
                box="multiselect"
                isClearable={true}
                options={this.state.dataVariant}
                value={this.props.filterData.kodeVariant}
                onChange={this.handleChangeVariant}
               />
              <SimpleDDL
                id={`select_options_nama_warna`}
                name="kodeWarna"
                label="Nama Warna"
                box="multiselect"
                isClearable={true}
                options={this.state.dataWarna}
                value={this.props.filterData.kodeWarna}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />
              <SimpleInput
                id="input_text_stnk_name"
                name="namaSTNK"
                label="Nama STNK"
                value={this.props.filterData.namaSTNK}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_buyer_name"
                name="namaPembeli"
                label="Nama Pembeli"
                value={this.props.filterData.namaPembeli}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_no_rangka"
                name="noKa"
                label="Nomor Rangka"
                value={this.props.filterData.noKa}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_no_mesin"
                name="noSin"
                label="Nomor Mesin"
                value={this.props.filterData.noSin}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />
            </FlexView>
            <FlexView hAlignContent="right" style={{ gap: "10px" }}>
              <SimpleButton
                type="button"
                text={"Hapus"}
                onClick={this.props.onClearForm}
              />
              <SimpleButton
                type="submit"
                text={"Terapkan"}
                onClick={this.props.onSubmit}
              />
            </FlexView>

            <SimpleLoadingOverlay active={this.state.loading} />
          </ModalContainer>
        }
      />
    );
  }
}

export default beforeSubmissionFilter;
